// TODO(jared): Add util methods for constructing routes (ex: featureById(id))
export function replaceWorkspace(path, workspace) {
  return path.replace(':workspace', workspace);
}

export function replacePlanId(path, workspace, planId) {
  return replaceWorkspace(path.replace(':planId', planId), workspace);
}
